import Lottie from 'lottie-react';
import { makeStyles } from '@material-ui/styles';
import { MDSIcon } from '@marqvision/mds-v2';
import magicIconAnimation from './magicIconAnimation.json';

const useStyles = makeStyles(({ _raw_color }) => ({
  icon: {
    '& path': {
      fill: 'url(#gradient) !important', // @morgan: MDSChip 내부에 넣으면 fill 이 닦여버려서 important 추가함
    },
  },
  gradientStart: {
    stopColor: _raw_color.blue400,
  },
  gradientEnd: {
    stopColor: _raw_color.purple500,
  },
}));

type Props = {
  animate?: boolean;
  size?: number;
};

export const StarIcon = (props: Props) => {
  const { animate, size = 20 } = props;
  const classes = useStyles();

  return animate ? (
    <Lottie animationData={magicIconAnimation} style={{ width: size, height: size, display: 'flex' }} />
  ) : (
    <svg
      width={size}
      height={size}
      className={classes.icon}
      style={{ width: `${size}px`, height: `${size}px`, flex: `0 0 ${size}px` }}
    >
      <defs>
        <linearGradient
          id="gradient"
          x1="9.99992"
          y1="0.833252"
          x2="9.99992"
          y2="19.1666"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.415" className={classes.gradientStart} />
          <stop offset="1" className={classes.gradientEnd} />
        </linearGradient>
      </defs>
      <MDSIcon.Magic size={size} />
    </svg>
  );
};
